import { ISuitabilityReport } from "@portal/types/robot/ISuitabilityReport";
import { ISuitabilityReportData } from "@portal/types/robot/ISuitabilityReportData";
import { IUseSuitabilityReport } from "./types";

const UseCreateSuitabilityReport: IUseSuitabilityReport = () => {
  const submitSuitabilityReport = async (req: ISuitabilityReportData) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    };
    const url = "/api/robot/SuitabilityReport/";
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      console.error(response.statusText);
      return undefined;
    }
    return (await response.json()) as ISuitabilityReport;
  };

  return { submitSuitabilityReport };
};

export default UseCreateSuitabilityReport;
